import Vue from 'vue'
import Router from 'vue-router'
import config from '../../config'

Vue.use(Router)

export default new Router({
  // mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  mode: 'history',
  base: (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'aztest') ? config.build.assetsPublicPath : config.dev.assetsPublicPath,
  routes: [
    { name: 'home', path: '/', component: () => import('@/components/Homepage/Home') },
    { name: 'login', path: '/login', component: () => import('@/components/Login'), props: route => ({ redirect: route.query.redirect }) },
    { path: '/administration', component: () => import('@/components/Administration') },

    // Manage Access
    { name: 'usermanage', path: '/administration/users', meta: { title: 'Manage Users', icon: 'settings', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/AdministrationUserManage') },
    { name: 'accessManage', path: '/administration/tenants', meta: { title: 'Manage Tenants', icon: 'settings', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/AdministrationAccessManage') },
    {
      name: 'accessManageEntrance',
      path: '/administration/tenants/:name',
      meta: {
        icon: 'settings',
        breadcrumbs: [
          { title: 'Administration Area', link: { name: '', }, },
          { title: 'Manage Tenants', link: { name: 'accessManage', }, },
          {
            title: 'Tenant',
            link: { name: '', },
          }
        ],
      },
      component: () => import('@/components/Administration/AdministrationAccessManageEntrance'),
    },
    // Manage Data
    { name: 'mediaTypeManage', path: '/administration/media-types', meta: { title: 'Manage Media Types', icon: 'settings', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/AdministrationMediaTypeManage') },
    { name: 'stationcategorymanage', path: '/administration/station-categories', meta: { title: 'Manage Station Categories', icon: 'settings', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/AdministrationStationCategoryManage') },
    { name: 'timeseriestagsmanage', path: '/administration/timeseries-tags', meta: { title: 'Manage Time Series Tags', icon: 'settings', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/AdministrationTimeSeriesTagManage') },    
    { name: 'manageaquariusstations', path: '/administration/manage-aquarius-stations', meta: { title: 'Manage Aquarius Stations', icon: '', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/AquariusStations/AquariusStations') },

    { name: 'roleDetail', path: '/administration/role-details/:name', meta: { icon: 'supervisor_account', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }, { title: 'Manage Tenants', link: { name: 'accessManage' } }, { title: 'Manage Access', link: { name: 'roleDetail' } }] }, component: () => import('@/components/Administration/Tenants/AdministrationRoleDetailManage'), props: true },
    { name: 'sideMenuDetail', path: '/administration/side-menu-details/:name', meta: { icon: 'supervisor_account', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }, { title: 'Manage Tenants', link: { name: 'accessManage' } }, { title: 'Manage Side Menu', link: { name: 'sideMenuDetail' } }] }, component: () => import('@/components/Administration/Tenants/AdministrationSideMenuDetail'), props: true },
    { name: 'fileExportDetail', path: '/administration/manage-file-export/:name', meta: { icon: 'cloud_download', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }, { title: 'Manage Tenants', link: { name: 'accessManage' } }, { title: 'Tenant and Project Names', link: { name: '' } }] }, component: () => import('@/components/Administration/Tenants/AdministrationFileExportManage'), props: true },
    { name: 'reportVisibilityDetail', path: '/administration/manage-report-visibility/:name', meta: { icon: 'ballot', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }, { title: 'Manage Tenants', link: { name: 'accessManage' } }, { title: 'Manage Report Visibility', link: { name: 'reportVisibilityDetail' } }] }, component: () => import('@/components/Administration/Tenants/AdministrationReportVisibilityManage'), props: true },
    { name: 'stationDashboardDetail', path: '/administration/manage-station-dashboard/:name', meta: { icon: 'cloud_download', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }, { title: 'Manage Tenants', link: { name: 'accessManage' } }, { title: 'Manage Station Dashboard', link: { name: 'stationDashboardDetail' } }] }, component: () => import('@/components/Administration/Tenants/AdministrationStationDashboardManage'), props: true },
    {
      name: 'staticContentManage',
      path: '/administration/manage-static-content/:name',
      meta: { icon: 'article', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }, { title: 'Manage Tenants', link: { name: 'accessManage' } }, { title: 'Manage Static Content', link: { name: 'staticContentManage' } }] },
      component: () => import('@/components/Administration/Tenants/AdministrationEditStaticContents'),
      props: true,
    },
    { name: 'mapLayerManage', path: '/administration/mapLayerManage/:name', meta: { icon: 'cloud_download', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }, { title: 'Manage Tenants', link: { name: 'accessManage' } }, { title: 'Configure Map Layer', link: { name: 'mapLayerManage' } }] }, component: () => import('@/components/AdministrationMapManage/AdministrationMapLayerManage'), props: true },
    { name: 'continuousDataManage', path: '/administration/continuousDataManage/:name', meta: { icon: 'bubble_chart', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }, { title: 'Manage Tenants', link: { name: 'accessManage' } }, { title: 'Manage Continuous Data', link: { name: 'continuousDataManage' } }] }, component: () => import('@/components/Administration/Tenants/AdministrationContinuousDataManage'), props: true },
    { name: 'continuousDataOutputManage', path: '/administration/continuousDataOutputManage/:name', meta: { icon: 'settings', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }, { title: 'Manage Tenants', link: { name: 'accessManage' } }, { title: 'Manage Continuous Data Outputs', link: { name: 'continuousDataOutputManage' } }] }, component: () => import('@/components/ContinuousDataOutputManage/ContinuousDataOutputManage'), props: true },
    { name: 'mapLayerDetail', path: '/administration/mapLayerDetail/:name', component: () => import('@/components/AdministrationMapManage/AdministrationMapLayerDetail'), props: true },
    { name: 'dataimportermanage', path: '/administration/dataImporter', meta: { title: 'Manage Continuous Data Importers', icon: 'settings', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/AdministrationContinuousDataImport') },
    { path: '/stations/dashboard/:name', component: () => import('@/components/Station'), props: true },
    { path: '/stations/:name', component: () => import('@/components/StationForm'), props: true },
    { path: '/parameters', component: () => import('@/components/Parameters') },
    { path: '/output', component: () => import('@/components/Output') },
    { name: 'import', path: '/import/:importId', meta: { title: 'Import Detail', icon: 'assignment', breadcrumbs: [{ title: 'Import Events', link: { name: 'allimports' } }] }, component: () => import('@/components/Imports/EDD/Import'), props: true },
    // { name: 'allimports', path: '/allimports', meta: { title: 'All Imports', icon: 'storage' }, component: () => import('@/components/AllImports') },
    // { name: 'stationmanage', path: '/manage/station', meta: { title: 'Stations', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, component: () => import('@/components/StationManage') },
    { name: 'allimports', path: '/import-events', meta: { title: 'Import Events', icon: 'event_note', fullScreen: true, hideFooter: true, hideScroll: true, breadcrumbs: [] }, component: () => import('@/components/Imports/IngestionResults') },
    { name: 'fileschemasmanage', path: '/manage/file-schemas', meta: { title: 'File Schemas', icon: 'integration_instructions', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, component: () => import('@/components/DataSets/DataSetMetadataSchemaManage') },
    { name: 'schemadetail', path: '/manage/file-schemas/detail/:id', meta: { icon: 'code', breadcrumbs: [{ title: 'Manage File Schema', link: { name: 'fileschemasmanage' } }, { title: 'File Schemas', link: { name: '' } }] }, component: () => import('@/components/DataSets/DataSetMetadataSchemaDetail'), props: true },

    { name: 'ecosurveyingestionsmanage', path: '/manage/ecosurvey-ingestion-schemas', meta: { title: 'Ecosurvey EDD Ingestion Schemas', icon: 'md-application', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, component: () => import('@/components/DataSets/EcosurveyIngestionSchemaManage') },
    
    { name: 'flagsManage', path: '/manage/flags/', meta: { title: 'Discrete Sample Flags', icon: 'flag', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, component: () => import('@/components/FlagsManage'), props: true },
    { name: 'flagsSysAdminManage', path: '/manage/:tenant/flags/', meta: { title: 'Flags', icon: 'flag', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, component: () => import('@/components/FlagsManage'), props: true },
    { name: 'depthHeightDatums', path: '/manage/depth-height-datums/', meta: { icon: 'height', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, component: () => import('@/components/Administration/Tenants/AdministrationDepthHeightDatumManage'), props: true },
    { name: 'depthHeightDatumsSysAdminManage', path: '/manage/:name/depth-height-datums', meta: { icon: 'height', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, component: () => import('@/components/Administration/Tenants/AdministrationDepthHeightDatumManage'), props: true },
    { path: '/samples', component: () => import('@/components/Samples') },
    { name: 'guidelines', path: '/guidelines', meta: { title: 'Guidelines' }, component: () => import('@/components/Guidelines') },
    { name: 'monitoringfeature', path: '/monitoring-locations/:monitoringFeatureId', meta: { title: 'Location', icon: 'satellite', breadcrumbs: [{ title: 'Monitoring Locations', link: { name: '' } }] }, component: () => import('@/components/MonitoringFeature/ViewMonitoringFeature'), props: true },
    { path: '/lab-data-export', component: () => import('@/components/LabDataExport') },
    // Raw Data Repository
    { name: 'browsedatasets', path: '/datasets/browse', meta: { title: 'Browse Files', icon: 'assignment', breadcrumbs: [{ title: 'Files', link: { name: 'datasets' } }] }, component: () => import('@/components/DataSets/DataSets') },
    { name: 'browserecyclebin', path: '/datasets/recyclebin', meta: { title: 'Browse Recycle Bin', icon: 'mdi-recycle', breadcrumbs: [{ title: 'Recycle Bin', link: { name: 'recyclebin' } }] }, component: () => import('@/components/DataSets/RecycleBin') },
    { name: 'datasets', path: '/datasets', meta: { title: 'Files' }, component: () => import('@/components/DataSets/DataSetsLanding') },
    { name: 'dataset', path: '/datasets/:id', meta: { icon: 'insert_drive_file', breadcrumbs: [{ title: 'Files', link: { name: 'datasets' } }, { title: 'Browse Files', link: { name: 'browsedatasets' } }] }, component: () => import('@/components/DataSets/DataSetFile'), props: true },
    // Service Registry
    { name: 'manageservices', path: '/administration/manage-services/', component: () => import('@/components/ServiceRegistry/Service/ShowServices') },
    { name: 'manageserviceconfigurations', meta: { icon: 'settings', title: 'Manage Service Configurations', breadcrumbs: [{ title: 'Manage Services', link: { name: 'manageservices' } }] }, path: '/administration/manage_services/:id', component: () => import('@/components/ServiceRegistry/Configurations/MasterUI') },
    { name: 'manageservicecredentials', path: '/administration/manage-service-credentials', component: () => import('@/components/ServiceRegistry/Credentials/ShowCredentials') },
    // Review Execution results
    { name: 'reviewingestionresults', path: '/review/ingestion-results/:executionId', meta: { title: 'Review Logs', hideFooter: true, hideScroll: true, breadcrumbs: [{ title: 'Import Events', link: { name: 'allimports' } }] }, component: () => import('@/components/Services/ReviewIngestionResults/ViewResult'), props: true },
    // Manage
    { name: 'importnotifications', meta: { title: 'Discrete Import Notifications', icon: 'notification_important', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, path: '/manage/import-notifications/', component: () => import('@/components/Manage/ImportNotifications/ImportNotifications') },
    { name: 'aquariusLogs', meta: { icon: 'comment_bank', title: 'Logs', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, path: '/administration/aquariusLogs', component: () => import('@/components/AquariusLogs/AquariusLogs') },

    // Ingestion Management
    { name: 'ingestionDashboard', path: '/administration/ingestion-dashboard', meta: { title: 'CDI Management', icon: 'cloud_sync', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/Ingestion/Dashboard') },
    { name: 'ingestionConfigs', path: '/administration/ingestion-configurations', meta: { title: 'Ingestion Configurations', icon: 'settings', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/Ingestion/Configurations') },
    { name: 'ingestionSchedules', path: '/administration/ingestion-schedules', meta: { title: 'Ingestion Schedules', icon: 'schedule', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/Ingestion/Schedules') },
    { name: 'ingestionJobs', path: '/administration/ingestion-jobs', meta: { title: 'Ingestion Job Runs', icon: 'history', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/Ingestion/JobRuns') },
    { name: 'ingestionJobDetail', path: '/administration/ingestion-jobs/:runId', meta: { icon: 'assignment', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }, { title: 'Ingestion Job Runs', link: { name: 'ingestionJobs' } }, { title: 'Job Detail', link: { name: '' } }] }, component: () => import('@/components/Administration/Ingestion/JobRunDetail'), props: true },
    { name: 'ingestionPhotoUpload', path: '/administration/ingestion-photos', meta: { title: 'Station Photo Upload', icon: 'add_a_photo', breadcrumbs: [{ title: 'Administration Area', link: { name: '' } }] }, component: () => import('@/components/Administration/Ingestion/PhotoUpload') },
    { name: 'continuousDataOutputTenantManage', meta: { title: 'Continuous Data Output Management', icon: 'settings', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, path: '/manage/continuousDataOutput/', component: () => import('@/components/ContinuousDataOutputManage/ContinuousDataOutputManage') },
    { name: 'managemonitoringfeatures', meta: { title: 'Monitoring Locations', icon: 'satellite', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, path: '/manage/monitoring_locations', component: () => import('@/components/Manage/MonitoringFeatures/MonitoringFeatures') },
    // Plugins
    { name: 'adminPlugins', path: '/administration/:serviceLink/:interfaceType', meta: { title: 'Plugins', breadcrumbs: [{ title: 'Manage', link: { name: '' } }] }, component: () => import('@/components/Manage/Plugins/Plugins'), props: true },
    // Reports
    { name: 'monthlyWaterQualityReport', path: '/reports/monthly-water-quality', meta: { breadcrumbs: [{ title: 'Reports', link: { name: '' } }] }, component: () => import('@/components/Reports/MonthlyWaterQuality') },
    { name: 'monthlyRISSReport', path: '/reports/monthly-RISS', meta: { breadcrumbs: [{ title: 'Reports', link: { name: '' } }] }, component: () => import('@/components/Reports/MonthlyRISS') },
    { name: 'exportAllDataReport', path: '/reports/export-all-data', meta: { breadcrumbs: [{ title: 'Reports', link: { name: '' } }] }, component: () => import('@/components/Reports/ExportAllData') },
    // Discrete Data report
    // { name: 'rFrameworkViewer', path: '/reports/r-framework-viewer', meta: { title: 'View Report', icon: 'analytics', fullScreen: true, breadcrumbs: [{ title: 'Reports', link: { name: '' } }] }, component: () => import('@/components/Reports/RFrameworkViewer'), props: true },
    // { name: 'sampleFrameworkReport', path: '/reports/sample-framework', meta: { title: 'Sample Framework Report', icon: 'analytics', fullScreen: true, breadcrumbs: [{ title: 'Reports', link: { name: '' } }] }, component: () => import('@/components/Reports/SampleFramework/SampleFramework') },
    { name: 'continuousDataQueryReport', path: '/reports/continuous-data-query', meta: { title: 'Continuous Data Query', breadcrumbs: [{ title: 'Reports', link: { name: '' } }] }, component: () => import('@/components/Reports/MultiStationQuery/MultiContinuousStationQuery') },
    { name: 'discreteDataQueryReport', path: '/reports/discrete-data-query', meta: { title: 'Discrete Data Query', breadcrumbs: [{ title: 'Reports', link: { name: '' } }] }, component: () => import('@/components/Reports/MultiStationQuery/MultiStationQuery') },
    //{ name: 'tenantGraphDashboard', path: '/report/tenant-graphing-dashboard', meta: { title: 'Graphing Dashboard', breadcrumbs: [{ title: 'Reports', link: { name: '' } }] }, component: () => import('@/components/Dashboard/TenantGraphDashboard') },
    { name: 'BCMOEReport', path: '/reports/BCMOE', meta: { title: 'BC MOE Report', icon: 'poll', breadcrumbs: [{ title: 'Reports', link: { name: '' } }] }, component: () => import('@/components/Reports/BCMOE/BCMOE') },
    { name: 'vegetativeMonitoringPlotList', path: '/vegetative-monitoring/plots', meta: { title: 'Vegetative Monitoring', breadcrumbs: [{ title: 'Vegetative Monitoring', link: { name: '' } }] }, component: () => import('@/components/VegetativeMonitoring/PlotList') },
    { name: 'vegetativeMonitoringPlotDetail', path: '/vegetative-monitoring/plots/:plotId', meta: { title: 'Plot Detail', breadcrumbs: [{ title: 'Vegetative Monitoring', link: { name: 'vegetativeMonitoringPlotList' } }, { title: 'Plot Detail' }] }, component: () => import('@/components/VegetativeMonitoring/PlotDetail'), props: true },
    { name: 'vegetativeMonitoringSpecimenDetail', path: '/vegetative-monitoring/specimens/:specimenId', meta: { title: 'Specimen Detail', breadcrumbs: [{ title: 'Vegetative Monitoring', link: { name: 'vegetativeMonitoringPlotList' } }, { title: 'Plot Detail' }, { title: 'Specimen Detail' }] }, component: () => import('@/components/VegetativeMonitoring/SpecimenDetail'), props: true },
    {
      name: 'analytesManage',
      path: '/manage/analytes',
      meta: {
        icon: 'group_work',
        breadcrumbs: [{
          title: 'Manage',
          link: {
            name: '',
          },
        }],
      },
      component: () => import('@/components/AnalytesManage/AnalyteManage'),
      props: true,
    },
    {
      name: 'analytesManageError',
      path: '/manage/fix-analytes',
      meta: {
        icon: 'collections',
        breadcrumbs: [{
          title: 'Manage',
          link: {
            name: '',
          },
        }, {
          title: 'Analytes',
          link: {
            name: 'analytesManage',
          },
        }, ],
      },
      component: () => import('@/components/AnalytesManage/AnalyteManageError'),
      props: true,
    },
    {
      name: 'AnalyteDetailManage',
      path: '/manage/analytes/:analyteId',
      meta: {
        breadcrumbs: [{
          title: 'Manage',
          link: {
            name: '',
          },
        }, {
          title: 'Analytes',
          link: {
            name: 'analytesManage',
          },
        }, ],
      },
      component: () => import('@/components/AnalytesManage/AnalyteDetailManage'),
      props: true,
    },
    {
      name: 'guidelinesManage',
      path: '/administration/guidelines',
      meta: {
        title: 'Guidelines',
        breadcrumbs: [{
          title: 'Administration Area',
          link: {
            name: '',
          },
        }, {
          title: 'Manage Guidelines',
          link: {
            name: '',
          },
        }],
      },
      component: () => import('@/components/Guidelines/GuidelinesManage'),
      props: true,
    },
    {
      name: 'guidelinesDetail',
      path: '/administration/guidelines-detail/:name',
      meta: {
        icon: 'collections',
        breadcrumbs: [{
          title: 'Administration Area',
          link: {
            name: '',
          },
        }, {
          title: 'Manage Guidelines',
          link: {
            name: 'guidelinesManage',
          },
        }, {
          title: 'Manage Guidelines Detail',
          link: {
            name: '',
          },
        }],
      },
      component: () => import('@/components/Guidelines/GuidelinesDetailManage'),
      props: true,
    },
    {
      name: 'guidelinesCofactorEntrance',
      path: '/manage/guidelines/',
      meta: {
        icon: 'rule',
        breadcrumbs: [{
          title: 'Manage',
          link: {
            name: '',
          },
        }],
      },
      component: () => import('@/components/CoFactorManage/GuidelinesCofactorEntrance'),
    },
    {
      name: 'tenantGuidelinesDetail',
      path: '/manage/guidelines/:name',
      meta: {
        icon: 'collections',
        breadcrumbs: [{
            title: 'Manage',
            link: {
              name: '',
            },
          },
          {
            title: 'Guidelines & Cofactors',
            link: {
              name: 'guidelinesCofactorEntrance',
            },
          },
          {
            title: 'Guideline',
            link: {
              name: '',
            },
          },
        ],
      },
      component: () => import('@/components/TenantGuidelinesManage/TenantGuidelinesDetailManage'),
      props: true,
    },
    {
      name: 'unitsmanage',
      path: '/manage/units',
      meta: {
        icon: 'collections',
        breadcrumbs: [{
            title: 'Administration Area',
            link: {
              name: '',
            },
          },
          {
            title: 'Manage Units',
            link: {
              name: '',
            },
          },
        ],
      },
      component: () => import('@/components/UnitsManage/UnitManage'),
    },
    {
      name: 'UnitGroupDetail',
      path: '/manage/unit-group-details/:unitGroupName',
      meta: {
        icon: 'collections',
        breadcrumbs: [{
            title: 'Administration Area',
            link: {
              name: '',
            },
          },
          {
            title: 'Manage Units',
            link: {
              name: 'unitsmanage',
            },
          },
          {
            title: 'Unit Group',
            link: {
              name: '',
            },
          },
        ],
      },
      component: () => import('@/components/UnitsManage/UnitGroupDetail'),
      props: true,
    },
    { name: '404', path: '/resource-not-found', component: () => import('@/components/404'), props: true },
    {
      path: '*',
      redirect: to => {
        return {
          name: '404',
          params: {
            badURL: to.fullPath,
          },
        }
      },
      component: () => import('@/components/404'),
    },    
    { name: 'MessageCenter', path: '/messagecenter', component: () => import('@/components/MessageCenter'), props: true },
    { name: 'Office365AuthResponse', path: '/Office365AuthResponse', component: () => import('@/components/Office365AuthResponse'), props: true },
    { name: 'UserProfile', path: '/profile', component: () => import('@/components/UserProfile'), props: true },
  ],
})
